import { JqueryHelperService } from './../jquery-helper.service';
import { Component, OnInit } from '@angular/core';
import { AppState } from '../models/app.state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { FilterService } from "../shared/filter.service";
import { Filter, FilterType } from "../models/Filter";
import { ProductService } from "../shared/product.service";

@Component({
  selector: 'ciu-product-window',
  templateUrl: './product-window.component.html',
  styleUrls: ['./product-window.component.css']
})
export class ProductWindowComponent implements OnInit {

  constructor(private store: Store<AppState>,
    private filterService: FilterService,
    private jqueryHelper: JqueryHelperService,
    private productService: ProductService) {
    this.loadingProductsSpinnerConfig = {
      backdropBorderRadius: '14px',
      fullScreenBackdrop: true
    };

    this.activeFilters$ = this.filterService.getActiveFilteres();
  }
  windows$;
  loading$: Observable<boolean>;
  loadingProductsSpinnerConfig: any;
  activeFilters$: Observable<Filter[]>;
  filt: Filter[] = [];

  ngOnInit() {
    this.windows$ = this.productService.loadWindows();
    // this.windows$ = this.store.select(store => store.windowsState.windows);
    this.loading$ = this.store.select(storeX => storeX.windowsState.loading);

  }

  getFilters(filters: Filter[]) {
    return filters.filter(f => f.type == FilterType.SEARCH);
  }

  onRemoveFilter(filter: Filter) {
    this.filterService.removeFilter(filter)
    this.jqueryHelper.resetSearchInput();
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/product-window/product-window.component.ts